<div style="height: 18em; display: flex; align-items: center; justify-content: center; color: #1db2f5; font-size: 25px">
  {{ successMsg }}
</div>
